// Image with text accordion

const accordiontitle = document.querySelectorAll(".img-text-accordion-title");

accordiontitle.forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      header.classList.remove("active");
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      header.classList.add("active");
    }
  });
});

// drawer menu search

var drawerSelector = document.querySelector(".drawer__search");
var searchSelector = document.querySelector(".site-header__search-container");
var headerselector = document.querySelector("#SiteHeader");
if(window.innerWidth <= 768){
    drawerSelector.append(searchSelector);
}else{
    headerselector.append(searchSelector);
}


// Product Page 
// if(document.body.className == 'template-product'){
  setTimeout(() => {
    const onetime = document.getElementById('onetime');
    const subscribe = document.getElementById('subscribe');
    const radio1 = document.getElementById('rc-radio1');
    const radio2 = document.getElementById('rc-radio2');
  
    onetime.addEventListener('click', () => radio2.click());
    subscribe.addEventListener('click', () => radio1.click());
    const [selectVal, inputElement] = [
      document.querySelector('#selling-plans-dropdown'),
      document.querySelector('.rc-selling-plans-dropdown__select')
    ];
    function handleSelectChange() {
      inputElement.value = this.value;
      console.log(inputElement,'inputElementinputElement')
      inputElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
    selectVal.addEventListener('change', handleSelectChange);
    handleSelectChange()
  }, 2000);
// }


// Product Grid  Height

if (window.screen.width > 480) {
  function setEHeight() {
    const maxHeight = () => {
      let heightarr = [];
      const elements = document.querySelectorAll(".grid-product__content .grid-product__title--heading");
      elements.forEach(function (element) {
        heightarr.push(element.offsetHeight);
      });
      return Math.max(...heightarr);
    };
    const getMaxHeight = maxHeight();
    const icons = document.querySelectorAll(".grid-product__content .grid-product__title--heading");
    icons.forEach(function (icon) {
      icon.style.height = getMaxHeight + "px";
    });
  }
  
  setEHeight();
}

